import _ from "lodash";
import { ll, LocalizedLanguage } from "../core/ll";
import { user } from "../core/user";
import { codes } from "../data/codes";
import { schemas } from "../data/schemas";

/*
* buildGridColumns
* Creates the column list for kendoui grid controls based on the args.schema name - from the z.Schema
* schema fields that are marked as required are displayed in the grid by default
*
* Use the args.show parameter to pass in an array of fields that should be displayed
* regardless of the required parameter value
*
* Use the args.hide parameter to pass in an array of fields that should be hidden
* regardless of the required parameter value
*/
export function buildGridColumns(args) {
    var columns = [];
    if (!args) {
        return [];
    }

    if (!args.schema) {
        return [];
    }
    var schema = _.cloneDeep(args.schema),
        show = args.show || [],
        exclude = args.exclude || [];

    if (args.schemaName &&
        user &&
        user.companyData &&
        user.companyData.UserDefinedFields &&
        user.companyData.UserDefinedFields.length > 0) {

        $.each(user.companyData.UserDefinedFields, function (index, udf) {
            if (udf.TableName == args.schemaName) {

                var type = "string";

                switch (udf.Type) {
                    case "INT":
                        type = "Int32";
                        break;
                    case "FLOAT":
                        type = "Decimal";
                        break;
                    case "DATE":
                        type = "UDFDate";
                        break;
                    case "TIME":
                        type = "UDFTime";
                        break;
                    case "DATETIME":
                        type = "UDFDateTime";
                        break;
                    case "ENUM":
                        type = "UDFEnum";
                        break;
                    case "SIGNATURE":
                        type = "Signature";
                        break;
                    case "URL":
                        type = "URL";
                        break;
                }

                schema.Properties[udf.BindName] = {
                    Type: type,
                    FieldTitle: udf.FieldName,
                    UserDefinedListId: udf.UserDefinedListId,
                    Sortable: false
                };
            }
        });
    }

    var names = Object.keys(schema.Properties);
    for (var i = 0; i < names.length; i++) {
        var name = names[i],
            navigationPropertyType = schema.Properties[name].ForeignKeyType;

        if (name == "IsDeleted" || name == "CreatedGroup") {
            continue;
        }

        if ($.inArray(name, args.codeColumnsToIgnore) != -1) {
            continue;
        }

        if (navigationPropertyType) {
            var navigationSchema = schemas[schema.Properties[name].ForeignKeyType],
                navigationName = null;

            $.each(schema.NavigationProperties, function (key, value) {
                if (value.MapTo == name) {
                    navigationName = key;
                    return false;
                }
            });

            if (codes[navigationPropertyType] && codes[navigationPropertyType].length > 0) {

                var primaryField = "CodeNumber",
                    secondaryField = "Value";

                if (!navigationSchema.Properties.CodeNumber) {
                    for (var prop in navigationSchema.Properties) {
                        if (navigationSchema.Properties.hasOwnProperty(prop)) {
                            if (navigationSchema.Properties[prop].Display == "primary") {
                                primaryField = prop;
                            }
                            if (navigationSchema.Properties[prop].Display == "secondary") {
                                secondaryField = prop;
                            }
                        }
                    }
                }

                var codeTitle = navigationPropertyType;

                if (LocalizedLanguage["Entity." + navigationPropertyType]) {
                    codeTitle = "Entity." + navigationPropertyType;
                }

                args.row = {
                    isCode: true,
                    codeFieldIdName: name,
                    title: ll("CodeNumberFormat").format(ll(codeTitle)),
                    codeName: navigationPropertyType,
                    codeProperty: primaryField
                };
                args.codeName = navigationPropertyType,
                args.name = navigationName + "." + primaryField;
                args.props = navigationSchema.Properties[primaryField];
                args.props.Type = "Code";
                args.codeProperty = primaryField;
                columns.push(buildGridColumn(args));

                args.row = {
                    isCode: true,
                    codeFieldIdName: name,
                    title: ll("CodeValueFormat").format(ll(codeTitle)),
                    codeName: navigationPropertyType,
                    codeProperty: secondaryField
                };
                args.name = navigationName + "." + secondaryField;
                args.props = navigationSchema.Properties[secondaryField];
                args.props.Type = "Code";
                args.codeProperty = secondaryField;
                columns.push(buildGridColumn(args));
            }
        } else {
            var props = schema.Properties[name];
            var row: any = {};

            if (props.FieldTitle) {
                row.title = props.FieldTitle;
            }

            if ((exclude.length == 0 || exclude.indexOf(name) == -1) &&
                ((name != "Custom" && (!name.match(/Id$/) || name == "Id" || name == "LastUpdatedUserId" || name == "CreatedUserId"))
                || show.indexOf(name) != -1)) {

                args.row = row;
                args.name = name;
                args.props = props;
                if (args.props.Type == "Code") {
                    args.codeName = args.schemaName;
                }
                columns.push(buildGridColumn(args));
            }
        }
    }

    return columns;
}

export function buildGridColumn(args) {
    var name = args.name,
        row = args.row,
        props = args.props,
        show = args.show || [],
        hide = args.hide || [],
        parentSchemaName = args.parentSchemaName || "",
        useNumericInputs = args.useNumericInputs || false,
        useCheckboxes = args.useCheckboxes || false,
        inputClasses = args.inputClasses || "";

    row.field = parentSchemaName + name;
    row.codeFieldIdName = parentSchemaName + row.codeFieldIdName;
    if (show && show.indexOf(name) != -1) {
        // always show it
    } else if (hide && hide.indexOf(name) != -1) {
        row.hidden = true;
    } else {
        row.hidden = props.Required == true ? false : true;
    }

    row.UserDefinedListId = props.UserDefinedListId;
    row.sortable = props.Sortable === undefined ? true : props.Sortable

    if (args.name == "LastUpdatedUserId" || args.name == "CreatedUserId") {
        row.template = `<span>#= z.userCache.getEmail(_.get(data, "${row.field}")) || "---" #</span>`;
        row.sortable = false;
        row.filterable = false;
    } else {
        row.template = getTemplateForType({
            type: props.Type,
            field: row.field,
            UserDefinedListId: props.UserDefinedListId,
            codeName: args.codeName,
            codeProperty: args.codeProperty,
            codeFieldIdName: row.codeFieldIdName
        });
    }

    switch (props.Type) {
        case "Int32":
            if (useNumericInputs) {
                if (props.Required) {
                    row.editor = function (container, options) {
                        $('<input required="true" class="pane-field-input ' +
                                inputClasses +
                                '" name="' +
                                options.field +
                                '">')
                            .appendTo(container)
                            .kendoNumericTextBox({ format: "{0:0}", decimals: 0, step: 1 });
                    };
                } else {
                    row.editor = function (container, options) {
                        $('<input class="pane-field-input ' + inputClasses + '" name="' + options.field + '">')
                            .appendTo(container)
                            .kendoNumericTextBox({ format: "{0:0}", decimals: 0, step: 1 });
                    };
                }
            }
            break;
        case "Decimal":
            if (useNumericInputs) {
                if (props.Required) {
                    row.editor = function (container, options) {
                        $('<input required="true" class="pane-field-input ' +
                                inputClasses +
                                '" name="' +
                                options.field +
                                '">')
                            .appendTo(container)
                            .kendoNumericTextBox({ format: "{0:0}", decimals: 2, step: 0.1 });
                    };
                } else {
                    row.editor = function (container, options) {
                        $('<input class="pane-field-input ' + inputClasses + '" name="' + options.field + '">')
                            .appendTo(container)
                            .kendoNumericTextBox({ format: "{0:0}", decimals: 2, step: 0.1 });
                    };
                }
            }
            break;
        case "Boolean":
            if (useCheckboxes) {
                row.editor = function (container, options) {
                    $('<div class="checkbox">' +
                            '<label class="checkbox-wrapper">' +
                            '<input type="checkbox" class="checkbox-input" name="' +
                            options.field +
                            '">' +
                            '<span class="checkbox-container">' +
                            '<span class="checkbox-check"></span>' +
                            "</span>" +
                            '<span class="checkbox-label"></span>' +
                            "</label>" +
                            "</div>")
                        .appendTo(container);
                };
            }
            break;
        default:
            if (name == "Notes" || name == "Comments" || name == "Description") {
                if (props.Required) {
                    row.editor = function (container, options) {
                        $('<textarea required="true" class="kendo-edit pane-field-input ' +
                                inputClasses +
                                ' content-box" name="' +
                                options.field +
                                '"></textarea>')
                            .appendTo(container);
                    };
                } else {
                    row.editor = function (container, options) {
                        $('<textarea class="kendo-edit pane-field-input ' +
                                inputClasses +
                                ' content-box" name="' +
                                options.field +
                                '"></textarea>')
                            .appendTo(container);
                    };
                }
            } else {
                if (props.Required) {
                    row.editor = function (container, options) {
                        $('<input required="true" class="kendo-edit pane-field-input ' +
                                inputClasses +
                                ' content-box" name="' +
                                options.field +
                                '">')
                            .appendTo(container);
                    };
                } else {
                    row.editor = function (container, options) {
                        $('<input class="kendo-edit pane-field-input ' +
                                inputClasses +
                                ' content-box" name="' +
                                options.field +
                                '">')
                            .appendTo(container);
                    };
                }
            }
    }

    return row;
}

export function getTemplateForType(args) {

    switch (args.type) {
        case "Date":
        case "UDFDate":
            return "# var temp = z.util.getChildDataFromObject(data, '" + args.field + "'); #" +
                                "<span>#= z.util.kendoFormatDate(temp) #</span>";
        case "OffsetTime":
        case "UDFTime":
            return "# var temp = z.util.getChildDataFromObject(data, '" + args.field + "'); #" +
                                "<span>#= z.util.kendoFormatTime(temp) #</span>";
        case "TimeOfDay":
            return "# var temp = z.util.getChildDataFromObject(data, '" + args.field + "'); #" +
                                "<span>#= z.util.kendoFormatAbsoluteTime(temp) #</span>";
        case "DateTime":
        case "UDFDateTime":
            return "# var temp = z.util.getChildDataFromObject(data, '" + args.field + "'); #" +
                                "<span>#= z.util.kendoFormatDateTime(temp) #</span>";
        case "Int32":
            return "# var temp = z.util.getChildDataFromObject(data, '" + args.field + "', '---'); #" +
                "<span>#= temp #</span>";
        case "Currency":
            return "# var temp = z.util.getChildDataFromObject(data, '" + args.field + "', '---'); #" +
                                "<span>#= z.toString(temp, 'c') #</span>";
        case "Decimal":
            return "# var temp = z.util.getChildDataFromObject(data, '" + args.field + "', '---'); #" +
                "<span>#= temp #</span>";
        case "Boolean":
            return "# var temp = z.util.getChildDataFromObject(data, '" + args.field + "', '---'); #" +
                "<span>#= temp #</span>";
        case "UDFEnum":
            return "# var id = z.util.getChildDataFromObject(data, '" + args.field + "', '---'); #" +
                                "<span>#= z.cf.getCustomFieldListValue(" + args.UserDefinedListId + ", id) #</span>";
        case "Code":
            return "# var id = z.util.getChildDataFromObject(data, '" + ((args.codeFieldIdName == undefined || args.codeFieldIdName == "undefined") ? "Id" : args.codeFieldIdName) + "'); #" +
                    "# var result;" +
                    "result = _.find(z.codes['" + (args.codeName || args.schemaName) + "'], function(d) { if (d.DivisionNumber && id === '') { id = null; } return d.Id == id; }); # " +
                    "<span>#= result ? result." + (args.codeProperty || args.field) + " : '---' #</span>";
        case "Signature":
            return "# var id = z.util.getChildDataFromObject(data, '" + args.field + "'); #" +
                    "<a class='link'> " +
                    "    <span class='grid-signature-link'>" +
                    "        #= id ? z.ll('ViewSignature') : '---' #" +
                    "    </span> " +
                    "</a>";
        case "URL":
            return "# var value = z.util.getChildDataFromObject(data, '" + args.field + "'); #" +
                    "<a class='link'> " +
                    "    <span class='grid-url-link'>" +
                    "#       if (value) { #" +
                    "#           var label = value.substring(0, value.indexOf('|')); #" +
                    "#           var url = value.substring(value.indexOf('|') + 1); #" +
                    "            #= label #" +
                    "#       } else { #" +
                    "            #= '---' #" +
                    "#       } #" +
                    "    </span> " +
                    "</a>";
        default:
            return "# var temp = z.util.getChildDataFromObject(data, '" + args.field + "', '---'); #" +
                "<span>#= temp #</span>";
    }
}
